var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"auth"}},[(!_vm.isMobileView)?_c('app-full-nav'):_vm._e(),(_vm.isMobileView)?_c('app-mob-nav'):_vm._e(),_c('router-view',{on:{"logged-in":_vm.loggedInFunc}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }